/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import type { IntegrationType } from 'embercom/objects/standalone/constants';

export default class Integration extends Model {
  @attr('number') integrationType!: IntegrationType;
  @attr('string') displayName!: string;
  @attr('string') externalIdentifier!: string;
  @attr('boolean') supportsHandover!: boolean;
  @attr('boolean') supportsExternalTicketHandover!: boolean;
  @attr('boolean') supportsExternalAgentHandover!: boolean;
}
